import { render, staticRenderFns } from "./registration-report.vue?vue&type=template&id=a5db778c&scoped=true"
import script from "./registration-report.vue?vue&type=script&lang=js"
export * from "./registration-report.vue?vue&type=script&lang=js"
import style0 from "./registration-report.vue?vue&type=style&index=0&id=a5db778c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5db778c",
  null
  
)

export default component.exports